import type { UnbuiltPlaceholders } from './hawk/processWidgets/model';

export const buildPlaceholders = async (
  arrayOfUnbuiltPlaceholders: UnbuiltPlaceholders[],
): Promise<HTMLElement[]> => {
  const unprocessedWidgets: HTMLElement[] = [];

  for (const unbuiltPlaceholders of arrayOfUnbuiltPlaceholders) {
    const { elements, callbackToBuildPlaceholder } = unbuiltPlaceholders;

    for (const element of elements) {
      if (element) {
        const unprocessedResult = await callbackToBuildPlaceholder({ element });
        unprocessedWidgets.push(...unprocessedResult);
      }
    }
  }

  return unprocessedWidgets;
};
